import { AppContainer } from '../app.types/state';
import { MenuContainer } from '../app.containers/MenuContainer';

export async function createMenuContainer(self: AppContainer): Promise<MenuContainer> {
  return new MenuContainer({ ...self.context });
}
